import Pusher from "pusher-js";

import config from "./config";

Pusher.logToConsole = false;

let socket = null;

export const getSocket = () => socket;

export const connect = () => {
  if (socket === null) {
    socket = new Pusher(config.pusher.key, {
      cluster: config.pusher.cluster,
      forceTLS: true,
    });
  }
};

export const disconnect = () => {
  if (socket !== null) {
    socket.disconnect();
    socket = null;
  }
};
